import { useRouter } from 'vue-router'
import { useBetslip, useGamesStore } from '@nsftx/seven-client-retail-vue-sgp'
import { useIntegrator } from '@nsftx/seven-client-retail-vue-integrator'
import { logService } from '@nsftx/seven-client-retail-utils'

const LOG_PREFIX = '[useTicketRebet]'

export const useTicketRebet = () => {
  const router = useRouter()
  const { betslipLinkCode, feBetslipId, betIds } = useBetslip()
  const { getGameLinkByCode } = useGamesStore()
  const { rebet } = useIntegrator()

  const rebetTicket = async () => {
    const linkCode = betslipLinkCode.value
    const gameLink = linkCode ? getGameLinkByCode(linkCode) : undefined

    if (!linkCode || !gameLink) {
      logService.error(`${LOG_PREFIX} Game link not found.`, {
        code: 'ST_TICKET_REBET_GAME_NOT_FOUND',
        feBetslipId: feBetslipId.value,
        details: {
          linkCode
        }
      })
      return
    }

    await router.push({ name: 'game', params: { linkCode } })

    if (!feBetslipId.value || !betIds.value) {
      logService.error(`${LOG_PREFIX} Missing required data for ticket rebet.`, {
        code: 'ST_TICKET_REBET_MISSING_DATA',
        feBetslipId: feBetslipId.value,
        details: {
          betIds: betIds.value,
          linkCode
        }
      })
      return
    }

    rebet(feBetslipId.value, betIds.value)

    logService.debug(`${LOG_PREFIX} Ticket rebet successful.`, {
      code: 'ST_TICKET_REBET_SUCCESS',
      feBetslipId: feBetslipId.value,
      details: {
        linkCode
      }
    })
  }

  return { rebetTicket }
}
